angular.module('dashboard').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/dashboard/views/alerts.html',
    "<div class=\"row\" ng-cloak ng-if=\"labs.length &&  displayLabResults ||  messages.length && displayMessages \">\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div class=\"panel panel-tile panel-flush rounded-corner-sm\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-heading tile-rounded-corner-top\"\r" +
    "\n" +
    "                ng-click=\"updateCollapseState()\"\r" +
    "\n" +
    "                ng-class=\"{'tile-rounded-corner-bottom': tile.IsCollapsed}\">\r" +
    "\n" +
    "                <div class=\"pull-right panel-collapser clickable\">\r" +
    "\n" +
    "                    <span ng-if=\"tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"arrow-expand\"></span>\r" +
    "\n" +
    "                    <span ng-if=\"!tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"arrow-collapse\"></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"panel-title clickable\">\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <img src=\"images/spacer.png\" class=\"alert-icon alert-svg\" alt=\"alert\">\r" +
    "\n" +
    "                        {{ ::'ALERTS' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div uib-collapse=\"tile.IsCollapsed\" class=\"panel-dashboard-tile-content-area\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div id=\"alerts-messages-div\" ng-if=\"messages.length && displayMessages\" ng-class=\"(labs.length) ? 'ap-margin-bottom-20' : ''\">\r" +
    "\n" +
    "                        <div class=\"panel-subheading-dashboard\">{{::'New Messages' | translate}}</div>\r" +
    "\n" +
    "                        <div class=\"row panel-row clickable\"\r" +
    "\n" +
    "                             id=\"alert-message-{{msg.MessageId}}\"\r" +
    "\n" +
    "                             ng-repeat=\"msg in messages\"\r" +
    "\n" +
    "                             ng-click=\"displayAlertMessageThread(msg)\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"col-xs-9\">\r" +
    "\n" +
    "                                <div class=\"ap-dashboard-message\">\r" +
    "\n" +
    "                                    <img class=\"ap-dashboard-message-photo extra-dark-grey-border border-width-md rounded-corner-md\"\r" +
    "\n" +
    "                                         lazy-src=\"{{::thumbnailSrc}}\" endpoint-base='patient'>\r" +
    "\n" +
    "                                    <div class=\"ap-dashboard-message-text\">\r" +
    "\n" +
    "                                        <p class=\"ap-dashboard-message-text-row\">\r" +
    "\n" +
    "                                            <span ng-if=\"msg.FromName !== null\">\r" +
    "\n" +
    "                                                {{msg.FromName}}&nbsp;&nbsp;|&nbsp;&nbsp;\r" +
    "\n" +
    "                                            </span>\r" +
    "\n" +
    "                                            {{msg.MessageHeaderText}}\r" +
    "\n" +
    "                                        </p>\r" +
    "\n" +
    "                                        <p class=\"ap-dashboard-message-text-row\" ng-bind-html=\"msg.MessageBodyText\"></p>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"col-xs-3\">\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span class=\"pull-right\" ap-date-formatter date=\"{{msg.CreateDateTime}}\" format=\"date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span class=\"pull-right\" ap-date-formatter date=\"{{msg.CreateDateTime}}\" format=\"time\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div id=\"alerts-labs-div\" ng-if=\"labs.length && displayLabResults\">\r" +
    "\n" +
    "                        <div class=\"panel-subheading-dashboard\">{{::'New Test Results' | translate}}</div>\r" +
    "\n" +
    "                        <div class=\"row panel-row clickable\"\r" +
    "\n" +
    "                             id=\"alert-lab-{{lab.Result.Id}}\"\r" +
    "\n" +
    "                             ng-repeat=\"lab in labs\"\r" +
    "\n" +
    "                             ng-click=\"displayAlertMyChartLabs()\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"col-xs-9\">\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis column-text\">\r" +
    "\n" +
    "                                    {{lab.Result.Description}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis column-subtext\">\r" +
    "\n" +
    "                                    <span>\r" +
    "\n" +
    "                                        {{::lab.Result.AttachmentType}}\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-3\">\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span class=\"pull-right\" ap-date-formatter date=\"{{lab.Result.ResultDateTime}}\" format=\"date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span class=\"pull-right\" ap-date-formatter date=\"{{lab.Result.ResultDateTime}}\" format=\"time\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                \r" +
    "\n" +
    "                <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and the Alerts dashboard tile could not be loaded.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{::'You do not have access to the Alerts dashboard tile.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/dashboard/views/appointments.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div class=\"panel panel-tile panel-flush rounded-corner-sm\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-heading tile-rounded-corner-top\"\r" +
    "\n" +
    "                 hm-propagation=\"true\"\r" +
    "\n" +
    "                 ng-click=\"updateCollapseState()\"\r" +
    "\n" +
    "                 ng-class=\"{'tile-rounded-corner-bottom': tile.IsCollapsed}\">\r" +
    "\n" +
    "                <div class=\"pull-right panel-collapser clickable\">\r" +
    "\n" +
    "                    <span ng-if=\"tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"arrow-expand\"></span>\r" +
    "\n" +
    "                    <span ng-if=\"!tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"arrow-collapse\"></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 visible-xs visible-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'myAppointments'}\">\r" +
    "\n" +
    "                    {{::'View' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 hidden-xs hidden-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'myAppointments'}\">\r" +
    "\n" +
    "                    {{::'View Appointments' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <div class=\"panel-title clickable\">\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <img src=\"images/spacer.png\" class=\"tile-icon tile-appointments\" alt=\"appointments-tile\">\r" +
    "\n" +
    "                        {{ ::'UPCOMING APPOINTMENTS' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div uib-collapse=\"tile.IsCollapsed\" class=\"panel-dashboard-tile-content-area\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div id=\"no-upcoming-appointments-div\" ng-if=\"!appointments.length\">\r" +
    "\n" +
    "                        {{:: 'No upcoming appointments are scheduled.' | translate }}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row\"\r" +
    "\n" +
    "                         id=\"upcoming-appointment-{{appt.AppointmentId}}\"\r" +
    "\n" +
    "                         ng-repeat=\"appt in appointments\" ng-if=\"!appt.AppointmentStatus.IsCanceledStatus\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-3\">\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                <ap-date-formatter date=\"{{appt.StartDateTime}}\"\r" +
    "\n" +
    "                                                format=\"monthname-dayofmonth\"></ap-date-formatter>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                @\r" +
    "\n" +
    "                                <ap-date-formatter date=\"{{appt.StartDateTime}}\" format=\"time\"></ap-date-formatter>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <!--<div>-->\r" +
    "\n" +
    "                                <!--{{::'Add to Calendar' | translate}}-->\r" +
    "\n" +
    "                            <!--</div>-->\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-7 col-sm-5\">\r" +
    "\n" +
    "                            <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                {{appt.AppointmentType.Name}}\r" +
    "\n" +
    "                                <span ng-if=\"appt.IsAppointmentToday\">&nbsp;&nbsp;({{appt.AppointmentStatus.Description}})</span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                                <div ng-if=\"appt.AppointmentType.Description\">\r" +
    "\n" +
    "                                    <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                        {{ appt.AppointmentType.Description | limitTo: limitTo}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                {{appt.Provider.Name}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                <a class=\"clickable\" data-toggle=\"modal\" data-target=\"#VisitMap-{{appt.AppointmentId}}\">\r" +
    "\n" +
    "                                    {{appt.VisitLocation.Name}}&nbsp;&nbsp;{{appt.VisitLocation.Address1}} |\r" +
    "\n" +
    "                                    {{appt.VisitLocation.City}}, {{appt.VisitLocation.State}} {{appt.VisitLocation.Zip}}\r" +
    "\n" +
    "                                </a>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-2 col-xs-flush col-sm-4 col-sm-reset-flush\">\r" +
    "\n" +
    "                            <button class=\"btn btn-default1 pull-right\" ng-show=\"appt.CanCheckIn && canCheckInFeature && !loading\" ng-click=\"appointmentCheckIn(appt)\">\r" +
    "\n" +
    "                                {{::'Check In Now' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"modal fade\" id=\"VisitMap-{{appt.AppointmentId}}\" tabindex=\"-1\" role=\"dialog\">\r" +
    "\n" +
    "                            <div class=\"modal-dialog\">\r" +
    "\n" +
    "                                <div class=\"modal-content\">\r" +
    "\n" +
    "                                    <div class=\"modal-header\">\r" +
    "\n" +
    "                                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span>\r" +
    "\n" +
    "                                        </button>\r" +
    "\n" +
    "                                        <h4 class=\"modal-title\" id=\"myModalLabel\">{{::'Patient Visit Map' |\r" +
    "\n" +
    "                                            translate}}</h4>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"modal-body\">\r" +
    "\n" +
    "                                        <ap-google-maps\r" +
    "\n" +
    "                                                address=\"appt.VisitLocation.Address1\"\r" +
    "\n" +
    "                                                city=\"appt.VisitLocation.City\"\r" +
    "\n" +
    "                                                state=\"appt.VisitLocation.State\"\r" +
    "\n" +
    "                                                zip=\"appt.VisitLocation.Zip\">\r" +
    "\n" +
    "                                        </ap-google-maps>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"modal-footer\">\r" +
    "\n" +
    "                                        <div class=\"row\">\r" +
    "\n" +
    "                                            <div class=\"col-xs-8 text-align-left\">\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    {{appt.Provider.Name}}\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    {{appt.VisitLocation.Name}}\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    {{appt.VisitLocation.Address1}} | {{appt.VisitLocation.City}},\r" +
    "\n" +
    "                                                    {{appt.VisitLocation.State}} {{appt.VisitLocation.Zip}}\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    {{appt.VisitLocation.PhoneNumber}}\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"col-xs-4\">\r" +
    "\n" +
    "                                                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">\r" +
    "\n" +
    "                                                    Close\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and the Upcoming Appointments dashboard tile could not be loaded.' |\r" +
    "\n" +
    "                        translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{::'You do not have access to the Upcoming Appointments dashboard tile.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/dashboard/views/billing.html',
    "<div class=\"row\" ng-cloak ng-if=\"model.owesUsMoney\">\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div class=\"panel panel-tile panel-flush rounded-corner-sm\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-heading tile-rounded-corner-top\"\r" +
    "\n" +
    "                 hm-propagation=\"true\"\r" +
    "\n" +
    "                 ng-click=\"updateCollapseState()\"\r" +
    "\n" +
    "                 ng-class=\"{'tile-rounded-corner-bottom': tile.IsCollapsed}\">\r" +
    "\n" +
    "                <div class=\"pull-right panel-collapser clickable\">\r" +
    "\n" +
    "                    <span ng-if=\"tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                    <span ng-if=\"!tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 visible-xs visible-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'billing'}\">\r" +
    "\n" +
    "                    {{::'View' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 hidden-xs hidden-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'billing'}\">\r" +
    "\n" +
    "                    {{::'View Billing' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <div class=\"panel-title clickable\">\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <img src=\"images/spacer.png\" class=\"tile-icon tile-billing\" alt=\"tile-billing\">\r" +
    "\n" +
    "                        {{ ::'TOTAL RESPONSIBLE PARTY BALANCE' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div uib-collapse=\"tile.IsCollapsed\" class=\"panel-dashboard-tile-content-area\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                    <div class=\"row panel-row\" ng-if=\"!model.DepositByFinancialCenterEnabled\">\r" +
    "\n" +
    "                        <div class=\"col-xs-3\">\r" +
    "\n" +
    "                            {{ ::model.PersonBalanceAll | currency }}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-6\">\r" +
    "\n" +
    "                            <ap-date-formatter date=\"{{model.Date}}\"\r" +
    "\n" +
    "                                               format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-3\">\r" +
    "\n" +
    "                            <button ng-show=\"makeAPaymentButtonEnabled\" ng-click=\"makeGenericOnlinePayment()\" class=\"btn btn-default1 pull-right\">\r" +
    "\n" +
    "                                <span class=\"ng-hide\" ng-show=\"transitioning\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                {{::'Make A Payment' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-if=\"model.DepositByFinancialCenterEnabled\">\r" +
    "\n" +
    "                        <div class=\"row panel-row-no-border-bottom\" ng-repeat=\"balance in model.FinancialCenterBalances\">\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-md-4 col-flush\">\r" +
    "\n" +
    "                                {{balance.FinancialCenterName}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-md-4\">\r" +
    "\n" +
    "                                {{balance.Balance | currency}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-md-4 col-flush-left\">\r" +
    "\n" +
    "                                <div class=\"align-right\">\r" +
    "\n" +
    "                                    <button ng-show=\"makeAPaymentButtonEnabled\" class=\"btn btn-default1\" ng-click=\"makeSpecificOnlinePayment({{balance}})\">\r" +
    "\n" +
    "                                        {{::'Make Online Payment' | translate}}\r" +
    "\n" +
    "                                    </button>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and the Patient Billing dashboard tile could not be loaded.' |\r" +
    "\n" +
    "                        translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{::'You do not have access to the Patient Billing dashboard tile.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/dashboard/views/chart.html',
    "<div class=\"row\" ng-cloak ng-if=\"labs.length\">\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div class=\"panel panel-tile panel-flush rounded-corner-sm\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-heading tile-rounded-corner-top\"\r" +
    "\n" +
    "                 hm-propagation=\"true\"\r" +
    "\n" +
    "                 ng-click=\"updateCollapseState()\"\r" +
    "\n" +
    "                 ng-class=\"{'tile-rounded-corner-bottom': tile.IsCollapsed}\">\r" +
    "\n" +
    "                <div class=\"pull-right panel-collapser clickable\">\r" +
    "\n" +
    "                    <span ng-if=\"tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                    <span ng-if=\"!tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 visible-xs visible-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'myChartVisitSummary'}\">\r" +
    "\n" +
    "                    {{::'View' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 hidden-xs hidden-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'myChartVisitSummary'}\">\r" +
    "\n" +
    "                    {{::'View Chart' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <div class=\"panel-title clickable\">\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <img src=\"images/spacer.png\" class=\"tile-icon chart-selected\" alt=\"chart-selected\">\r" +
    "\n" +
    "                        {{ ::'CHART UPDATES' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div uib-collapse=\"tile.IsCollapsed\" class=\"panel-dashboard-tile-content-area\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                    <div id=\"no-labs-div\" ng-if=\"!labs.length\">\r" +
    "\n" +
    "                        {{::'No new test results were found.' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div id=\"labs-div\" ng-if=\"labs.length\">\r" +
    "\n" +
    "                        <div class=\"panel-subheading-dashboard\">{{::'New Test Results' | translate}}</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"row panel-row clickable\"\r" +
    "\n" +
    "                             id=\"lab-{{lab.Result.Id}}\"\r" +
    "\n" +
    "                             ng-repeat=\"lab in labs\"\r" +
    "\n" +
    "                             ng-click=\"displayMyChartLabs()\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"col-xs-9\">\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    {{lab.Result.Description}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span>\r" +
    "\n" +
    "                                        {{::lab.Result.AttachmentType}}\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-3\">\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span class=\"pull-right\" ap-date-formatter date=\"{{lab.Result.ResultDateTime}}\" format=\"date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span class=\"pull-right\" ap-date-formatter date=\"{{lab.Result.ResultDateTime}}\" format=\"time\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and the Chart Updates dashboard tile could not be loaded.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{::'You do not have access to the Chart Updates dashboard tile.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/dashboard/views/dashboard.html',
    "<div id=\"dashboard\" class=\"container-fluid container-flush\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-xs-flush col-md-2\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                    <div class=\"dashboard-tile row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-3 col-md-12 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"panel-photo-dashboard col-md-12\">\r" +
    "\n" +
    "                                <img lazy-src=\"{{::patient.userId | apPatientPortalThumbnailSrc:150:150}}\" endpoint-base='patient' alt=\"patient-image\">\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-9 col-md-12 col-xs-flush pull-left\">\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"dashboard-patient col-xs-12 col-xs-flush\">{{'Patient'|translate}}</div>\r" +
    "\n" +
    "                                <div class=\"dashboard-name col-xs-12 col-xs-flush\"><span class=\"dashboard-name\">{{::patient.name}}</span></div>\r" +
    "\n" +
    "                                <div class=\"dashboard-date col-xs-12 col-xs-flush\"><ap-date-formatter date=\"{{patient.birthDate}}\" format=\"long-date\"></ap-date-formatter></div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row\" ng-if=\"patient.providerName\">\r" +
    "\n" +
    "                                <div class=\"dashboard-patient col-xs-12 col-xs-flush\">{{'Provider'|translate}}</div>\r" +
    "\n" +
    "                                <div class=\"dashboard-date col-xs-12 col-xs-flush dashboard-font\">{{::patient.providerName}}</div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row\" ng-if=\"patient.serviceSite\">\r" +
    "\n" +
    "                                <div class=\"dashboard-patient col-xs-12 col-xs-flush\">{{'Service Site'|translate}}</div>\r" +
    "\n" +
    "                                <div class=\"dashboard-date col-xs-12 col-xs-flush dashboard-font\">{{::patient.serviceSite}}</div>\r" +
    "\n" +
    "                                <div class=\"dashboard-date col-xs-12 col-xs-flush dashboard-font\" ng-if=\"patient.serviceSiteAddress1\">{{::patient.serviceSiteAddress1}}</div>\r" +
    "\n" +
    "                                <div class=\"dashboard-date col-xs-12 col-xs-flush dashboard-font\" ng-if=\"patient.serviceSiteAddress2\">{{::patient.serviceSiteAddress2}}</div>\r" +
    "\n" +
    "                                <div class=\"dashboard-date col-xs-12 col-xs-flush dashboard-font\" ng-if=\"patient.serviceSiteLocation\">{{::patient.serviceSiteLocation}}</div>\r" +
    "\n" +
    "                                <div class=\"dashboard-date col-xs-12 col-xs-flush dashboard-font\" ng-if=\"patient.serviceSitePhoneNumber\">{{::patient.serviceSitePhoneNumber}}</div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row\" ng-if=\"showLinkPersonalHealthApp\">\r" +
    "\n" +
    "                                <div id=\"personal-health-app-link\" class=\"dashboard-patient col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                    <a ng-click=\"showPersonalHealthAppModal()\"><u>{{::'Link a Personal Health App'|translate}}</u></a>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-md-10 flush-right\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                    <div ng-repeat=\"tile in activeTiles\">\r" +
    "\n" +
    "                        <div ng-switch=\"tile.Name\">\r" +
    "\n" +
    "                            <div ng-switch-when=\"Alerts\">\r" +
    "\n" +
    "                                <div id=\"dashboard-tile-{{$index}}\"\r" +
    "\n" +
    "                                     ng-include=\"'/dashboard/views/alerts.html'\"\r" +
    "\n" +
    "                                     ng-controller=\"AlertsDashboardCtrl\"\r" +
    "\n" +
    "                                     ng-init=\"load(tile)\">\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"Forms\">\r" +
    "\n" +
    "                                <div id=\"dashboard-tile-{{$index}}\"\r" +
    "\n" +
    "                                     ng-include=\"'/dashboard/views/forms.html'\"\r" +
    "\n" +
    "                                     ng-controller=\"FormsDashboardCtrl\"\r" +
    "\n" +
    "                                     ng-init=\"load(tile)\">\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"Messages\">\r" +
    "\n" +
    "                                <div id=\"dashboard-tile-{{$index}}\"\r" +
    "\n" +
    "                                     ng-include=\"'/dashboard/views/messages.html'\"\r" +
    "\n" +
    "                                     ng-controller=\"MessagesDashboardCtrl\"\r" +
    "\n" +
    "                                     ng-init=\"load(tile)\">\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"Chart\">\r" +
    "\n" +
    "                                <div id=\"dashboard-tile-{{$index}}\"\r" +
    "\n" +
    "                                     ng-include=\"'/dashboard/views/chart.html'\"\r" +
    "\n" +
    "                                     ng-controller=\"ChartDashboardCtrl\"\r" +
    "\n" +
    "                                     ng-init=\"load(tile)\">\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"Prescriptions\">\r" +
    "\n" +
    "                                <div id=\"dashboard-tile-{{$index}}\"\r" +
    "\n" +
    "                                     ng-include=\"'/dashboard/views/prescriptions.html'\"\r" +
    "\n" +
    "                                     ng-controller=\"PrescriptionsDashboardCtrl\"\r" +
    "\n" +
    "                                     ng-init=\"load(tile)\">\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"Appointments\">\r" +
    "\n" +
    "                                <div id=\"dashboard-tile-{{$index}}\"\r" +
    "\n" +
    "                                     ng-include=\"'/dashboard/views/appointments.html'\"\r" +
    "\n" +
    "                                     ng-controller=\"AppointmentsDashboardCtrl\"\r" +
    "\n" +
    "                                     ng-init=\"load(tile)\">\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"Billing\">\r" +
    "\n" +
    "                                <div id=\"dashboard-tile-{{$index}}\"\r" +
    "\n" +
    "                                     ng-include=\"'/dashboard/views/billing.html'\"\r" +
    "\n" +
    "                                     ng-controller=\"BillingDashboardCtrl\"\r" +
    "\n" +
    "                                     ng-init=\"load(tile)\">\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and the patient dashboard could not be loaded.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{::'You do not have access to the patient dashboard.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                    <div ng-if=\"(!activeTiles || !activeTiles.length)\">\r" +
    "\n" +
    "                        <div class=\"row\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                <div class=\"panel panel-default panel-flush\">\r" +
    "\n" +
    "                                    <div class=\"panel-body text-center\">\r" +
    "\n" +
    "                                        <uib-alert type=\"warning\">\r" +
    "\n" +
    "                                            {{::'Your dashboard does not have any tiles configured.' | translate}}\r" +
    "\n" +
    "                                        </uib-alert>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/dashboard/views/forms.html',
    "<div class=\"row\" ng-cloak ng-if=\"incompleteFormsList.length || practiceFormsList.length\">\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div class=\"panel panel-tile panel-flush rounded-corner-sm\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-heading tile-rounded-corner-top\"\r" +
    "\n" +
    "                 hm-propagation=\"true\"\r" +
    "\n" +
    "                 ng-click=\"updateCollapseState()\"\r" +
    "\n" +
    "                 ng-class=\"{'tile-rounded-corner-bottom': tile.IsCollapsed}\">\r" +
    "\n" +
    "                <div class=\"pull-right panel-collapser clickable\">\r" +
    "\n" +
    "                    <span ng-if=\"tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                    <span ng-if=\"!tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 visible-xs visible-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'forms'}\">\r" +
    "\n" +
    "                    {{::'View' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 hidden-xs hidden-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'forms'}\">\r" +
    "\n" +
    "                    {{::'View Forms' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <div class=\"panel-title clickable\">\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <img src=\"images/spacer.png\" class=\"tile-icon forms-selected\" alt=\"forms-selected\">\r" +
    "\n" +
    "                        {{ ::'FORM UPDATES' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div uib-collapse=\"tile.IsCollapsed\" class=\"panel-dashboard-tile-content-area\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div id=\"forms-questionnaires-div\" ng-if=\"incompleteFormsList.length\" ng-class=\"(practiceFormsList.length) ? 'ap-margin-bottom-20' : ''\">\r" +
    "\n" +
    "                        <div class=\"panel-subheading-dashboard\">{{::'Incomplete Questionnaires' | translate}}</div>\r" +
    "\n" +
    "                        <div class=\"row panel-row\"\r" +
    "\n" +
    "                             id=\"form-{{incompleteForm.QuestionnaireId}}\"\r" +
    "\n" +
    "                             ng-repeat=\"incompleteForm in incompleteFormsList track by $index\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"col-xs-4\">\r" +
    "\n" +
    "                                <div>{{ incompleteForm.QuestionnaireName }}</div>\r" +
    "\n" +
    "                                <!--<div>-->\r" +
    "\n" +
    "                                    <!--{{ ::'Last Edited' | translate }}-->\r" +
    "\n" +
    "                                    <!--<ap-date-formatter date=\"{{incompleteForm.LastModifiedByPatient}}\" format=\"monthname-dayofmonth\"></ap-date-formatter>-->\r" +
    "\n" +
    "                                    <!--<span class=\"ap-dashboard-form-datetime-separator\">*</span>-->\r" +
    "\n" +
    "                                    <!--<ap-date-formatter date=\"{{incompleteForm.LastModifiedByPatient}}\" format=\"time\"></ap-date-formatter>-->\r" +
    "\n" +
    "                                <!--</div>-->\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    {{::'Assigned' | translate}}\r" +
    "\n" +
    "                                    <ap-date-formatter date=\"{{incompleteForm.EffectDate}}\"\r" +
    "\n" +
    "                                                       format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-4\">\r" +
    "\n" +
    "                                <div ng-if=\"!incompleteForm.LastModifiedByPatient\">\r" +
    "\n" +
    "                                    {{::'New' | translate}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"incompleteForm.LastModifiedByPatient\">\r" +
    "\n" +
    "                                    <div>{{::'In Progress' | translate}}</div>\r" +
    "\n" +
    "                                    {{::'Last Edited' | translate}}\r" +
    "\n" +
    "                                    <ap-date-formatter date=\"{{incompleteForm.LastModifiedByPatient}}\"\r" +
    "\n" +
    "                                                       format=\"date-time\"></ap-date-formatter>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-4\">\r" +
    "\n" +
    "                                <button\r" +
    "\n" +
    "                                        class=\"btn btn-default1 pull-right\"\r" +
    "\n" +
    "                                        data-toggle=\"modal\"\r" +
    "\n" +
    "                                        ng-click=\"openPatientQuestionnaire(incompleteForm)\">\r" +
    "\n" +
    "                                    {{::'Complete Form' | translate}}\r" +
    "\n" +
    "                                </button>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div id=\"forms-practiceforms-div\" ng-if=\"practiceFormsList.length\">\r" +
    "\n" +
    "                        <div class=\"panel-subheading-dashboard\">{{::'New Practice Forms' | translate}}</div>\r" +
    "\n" +
    "                        <div class=\"row panel-row clickable\"\r" +
    "\n" +
    "                             id=\"practice-form-{{practiceForm.RelPracticeFormPatientId}}\"\r" +
    "\n" +
    "                             ng-repeat=\"practiceForm in practiceFormsList track by $index\"\r" +
    "\n" +
    "                             ng-click=\"displayForms()\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"col-xs-9\">\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis column-text\">\r" +
    "\n" +
    "                                    {{practiceForm.PracticeFormName}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis column-subtext\">\r" +
    "\n" +
    "                                    <span>{{practiceForm.AttachmentTypeName}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-3\">\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span class=\"pull-right\" ap-date-formatter date=\"{{practiceForm.EffectDate}}\" format=\"date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    <span class=\"pull-right\" ap-date-formatter date=\"{{practiceForm.EffectDate}}\" format=\"time\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and the Forms dashboard tile could not be loaded.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{::'You do not have access to the Forms dashboard tile.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/dashboard/views/messages.html',
    "<div class=\"row\" ng-cloak ng-if=\"messages.length\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div class=\"panel panel-tile panel-flush rounded-corner-sm\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-heading tile-rounded-corner-top\"\r" +
    "\n" +
    "                 hm-propagation=\"true\"\r" +
    "\n" +
    "                 ng-click=\"updateCollapseState()\"\r" +
    "\n" +
    "                 ng-class=\"{'tile-rounded-corner-bottom': tile.IsCollapsed}\">\r" +
    "\n" +
    "                <div class=\"pull-right panel-collapser clickable\">\r" +
    "\n" +
    "                    <span ng-if=\"tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                    <span ng-if=\"!tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 visible-xs visible-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'myMessagesMobile', opts: {folder: 'inbox'}}\">\r" +
    "\n" +
    "                    {{::'View' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 hidden-xs hidden-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'myMessagesDisplayMessages', opts: {displayMode: 'received'}}\">\r" +
    "\n" +
    "                    {{::'View Messages' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <div class=\"panel-title clickable\">\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <img src=\"images/spacer.png\" class=\"tile-icon messages-selected\" alt=\"messages-selected\">\r" +
    "\n" +
    "                        {{ ::'NEW MESSAGES' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div uib-collapse=\"tile.IsCollapsed\" class=\"panel-dashboard-tile-content-area\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                    <div id=\"no-messages-div\" ng-if=\"!messages.length\">\r" +
    "\n" +
    "                        {{::'No new messages were found.' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row clickable\"\r" +
    "\n" +
    "                         id=\"message-{{msg.MessageId}}\"\r" +
    "\n" +
    "                         ng-repeat=\"msg in messages\"\r" +
    "\n" +
    "                         ng-click=\"displayMessageThread(msg)\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-9\">\r" +
    "\n" +
    "                            <div class=\"ap-dashboard-message\">\r" +
    "\n" +
    "                                <img class=\"ap-dashboard-message-photo extra-dark-grey-border border-width-md rounded-corner-md\"\r" +
    "\n" +
    "                                     lazy-src=\"{{::thumbnailSrc}}\" endpoint-base='patient'>\r" +
    "\n" +
    "                                <div class=\"ap-dashboard-message-text\">\r" +
    "\n" +
    "                                    <p class=\"ap-dashboard-message-text-row\">\r" +
    "\n" +
    "                                        <span ng-if=\"msg.FromName !== null\">\r" +
    "\n" +
    "                                            {{msg.FromName}}&nbsp;&nbsp;|&nbsp;&nbsp;\r" +
    "\n" +
    "                                        </span>\r" +
    "\n" +
    "                                        {{msg.MessageHeaderText}}\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                    <p class=\"ap-dashboard-message-text-row\" ng-bind-html=\"msg.MessageBodyText\"></p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-3\">\r" +
    "\n" +
    "                            <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                <span class=\"pull-right\" ap-date-formatter date=\"{{msg.CreateDateTime}}\" format=\"date\"></span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                <span class=\"pull-right\" ap-date-formatter date=\"{{msg.CreateDateTime}}\" format=\"time\"></span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and the New Messages dashboard tile could not be loaded.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{::'You do not have access to the New Messages dashboard tile.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/dashboard/views/prescriptions.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div class=\"panel panel-tile panel-flush rounded-corner-sm\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-heading tile-rounded-corner-top\"\r" +
    "\n" +
    "                 hm-propagation=\"true\"\r" +
    "\n" +
    "                 ng-click=\"updateCollapseState()\"\r" +
    "\n" +
    "                 ng-class=\"{'tile-rounded-corner-bottom': tile.IsCollapsed}\">\r" +
    "\n" +
    "                <div class=\"pull-right panel-collapser clickable\">\r" +
    "\n" +
    "                    <!--<span ng-class=\"{'ap-chevron-down-blue': tile.IsCollapsed, 'ap-chevron-up-blue': !tile.IsCollapsed}\"></span>-->\r" +
    "\n" +
    "                    <span ng-if=\"tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                    <span ng-if=\"!tile.IsCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 visible-xs visible-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'prescriptionsMobile'}\">\r" +
    "\n" +
    "                    {{::'View' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 hidden-xs hidden-sm pull-right-inline\"\r" +
    "\n" +
    "                        hm-stop-propagation=\"true\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'prescriptions'}\">\r" +
    "\n" +
    "                    {{::'View Prescriptions' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <div class=\"panel-title clickable\">\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <img src=\"images/spacer.png\" class=\"tile-icon prescriptions-selected\" alt=\"prescriptions-selected\">\r" +
    "\n" +
    "                        {{ ::'RECENT PRESCRIPTIONS' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div uib-collapse=\"tile.IsCollapsed\" class=\"panel-dashboard-tile-content-area\">\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                    <div id=\"no-medications-div\" ng-if=\"!medicationsExist\">\r" +
    "\n" +
    "                        {{::'No recent prescriptions were found.' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div id=\"medication-{{med.RelPatientMedicationId}}\"\r" +
    "\n" +
    "                         class=\"row panel-row\"\r" +
    "\n" +
    "                         ng-repeat=\"med in currentPrescriptions\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush col-md-5\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                                {{::med.DrugName}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-12 smaller\">\r" +
    "\n" +
    "                                {{::med.Instructions}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-4 col-flush\">\r" +
    "\n" +
    "                            <div class=\"row-item col-xs-12\">\r" +
    "\n" +
    "                                <div class=\"col-xs-2 smaller\">\r" +
    "\n" +
    "                                    {{::'Start' | translate}}&nbsp;\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-10\">\r" +
    "\n" +
    "                                    <span ap-date-formatter date=\"{{::med.StartDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row-item col-xs-12\">\r" +
    "\n" +
    "                                <div class=\"col-xs-2 smaller\">\r" +
    "\n" +
    "                                    {{::'End' | translate}}&nbsp;\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-10\">\r" +
    "\n" +
    "                                    <span ap-date-formatter date=\"{{::med.EndDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-3\">\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"!med.RefillRequestPending && !med.IsDiscontinued && med.ProviderId\">\r" +
    "\n" +
    "                                <button class=\"btn btn-lg-height btn-default1\" ng-click=\"medSelect(med)\"\r" +
    "\n" +
    "                                        data-transition-to=\"{appRoute: 'rxrefill'}\">{{'Request Refill' | translate}}\r" +
    "\n" +
    "                                </button>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"med.IsDiscontinued\">\r" +
    "\n" +
    "                                <div class=\"btn-height flexbox flexbox-horizontal-center\"><span\r" +
    "\n" +
    "                                        class=\"btn-width pending text-center\">{{'Discontinued' | translate}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"med.RefillRequestPending\">\r" +
    "\n" +
    "                                <button class=\"btn btn-lg-height btn-default1 btn-minpadding\" ng-click=\"medSelect(med)\"\r" +
    "\n" +
    "                                        data-transition-to=\"{appRoute: 'rxrefill'}\"><span class=\"lime-green\">{{'Refill Requested' | translate}}</span>\r" +
    "\n" +
    "                                </button>\r" +
    "\n" +
    "                                <div class=\"pending text-center\">{{'Pending Review' | translate}}</div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"!med.ProviderId\">\r" +
    "\n" +
    "                                <div class=\"btn-height flexbox flexbox-horizontal-center\"><span\r" +
    "\n" +
    "                                        class=\"btn-width pending text-center\">{{'Please contact office to process.' | translate}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and the Recent Prescriptions dashboard tile could not be loaded.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{::'You do not have access to the Recent Prescriptions dashboard tile.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );

}]);
